// src/components/ActiveModuleContext.jsx

import React, { createContext, useState, useContext } from "react";

// 1. Crear el contexto
const ActiveModuleContext = createContext();

// 2. Crear el proveedor del contexto
export const ActiveModuleProvider = ({ children }) => {
  const [activeModule, setActiveModule] = useState("Noticias"); // Valor inicial

  return (
    <ActiveModuleContext.Provider value={{ activeModule, setActiveModule }}>
      {children}
    </ActiveModuleContext.Provider>
  );
};

// 3. Crear un hook para consumir el contexto fácilmente
export const useActiveModule = () => {
  const context = useContext(ActiveModuleContext);
  if (!context) {
    throw new Error(
      "useActiveModule debe ser usado dentro de un ActiveModuleProvider"
    );
  }
  return context;
};

